module.exports = "<div>\n  <div style=\"display: block\">\n    <canvas #chartNbVehicleTypes></canvas>\n  </div>\n</div>"